// extracted by mini-css-extract-plugin
module.exports = {"SpinnerContainer":"Spinner_SpinnerContainer__2nTcD","Dark":"Spinner_Dark__2PlK8","Light":"Spinner_Light__3Zc6n","Spinner":"Spinner_Spinner__BWqNs"};